import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import {ToasterService} from '../toaster.service';
//sessionStorage.setItem("isLogedin",'false');

import { Router, RouterModule } from '@angular/router';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {



constructor(private dataService:DataService,private router:Router, private toastr: ToasterService) { }
login:string="yes";
login_msg:string="";
loginuser(param)
{
  this.dataService.isload=true;
this.dataService.getuser(param.user,param.pass).subscribe(
res=>
{
//console.log(response);
if(res['status']==1)
{

  //console.log("xxxxxxx",res['data']);
  this.toastr.showSuccess(res['message']);
  
  sessionStorage.setItem("client_id", res['data']['id']);
  sessionStorage.setItem("profile_id", res['data']['profile_id']);
  sessionStorage.setItem("username", res['data']['username']);
  sessionStorage.setItem("firstName", res['data']['f_name']);
  sessionStorage.setItem("lastName", res['data']['l_name']);
  sessionStorage.setItem("email", res['data']['email']);
  sessionStorage.setItem("phoneNo", res['data']['telephone']);
  sessionStorage.setItem("location", res['data']['address']);
  sessionStorage.setItem("account_manager_email", res['data']['account_manage_email']);
  sessionStorage.setItem("account_manager_id", res['data']['account_manager_id']);
  sessionStorage.setItem("account_manage_name", res['data']['account_manage_name']);
  sessionStorage.setItem("account_manage_profile_image", res['data']['account_manage_profile_image']);
  sessionStorage.setItem("client_profile_image", res['data']['client_profile_image']);
  sessionStorage.setItem("display_name", res['data']['display_name']);
  sessionStorage.setItem("am_mobile", res['data']['am_mobile']);
  sessionStorage.setItem("auth_token", res['data']['auth_token']);
  sessionStorage.setItem("entity_type", res['data']['entity_type']);
  sessionStorage.setItem("ga_view_id", res['data']['ga_view_id']);
  sessionStorage.setItem("website", (res['data']['website']).trim());
  sessionStorage.setItem("is_web", res['data']['web']);
  sessionStorage.setItem("twitter_id", res['data']['twitter_id']);
  sessionStorage.setItem("linkedIn_id", res['data']['likedin_id']);
  sessionStorage.setItem("fb_page_id", res['data']['fb_page_id']);
  sessionStorage.setItem("jira_user", res['data']['jira_username']);
  sessionStorage.setItem("is_seo", res['data']['seo']);
  sessionStorage.setItem("is_newseo", res['data']['seo']);  // new seo report
  sessionStorage.setItem("is_rm", res['data']['mypr']);
  sessionStorage.setItem("is_sm", res['data']['sm']);
  sessionStorage.setItem("is_newsm", res['data']['sm']); //new social media
  sessionStorage.setItem("sf_id", res['data']['sf_id']);
  sessionStorage.setItem("seo_state", res['data']['seo_state']);
  sessionStorage.setItem("state_longitude", res['data']['state_longitude']);
  sessionStorage.setItem("state_latitude", res['data']['state_latitude']);
  sessionStorage.setItem("mypr_access_key", res['data']['mypr_access_key']);
  sessionStorage.setItem("isLogedin",'true');
  sessionStorage.setItem("is_pageviews",res['data']['is_pageviews']);
  sessionStorage.setItem("gmb",res['data']['gmb_location']);
  sessionStorage.setItem("average_patient_spend",res['data']['average_patient_spend']);
  sessionStorage.setItem("lead_conversion_rate",res['data']['lead_conversion_rate']);

  sessionStorage.setItem("web_admin_name",res['data']['web_admin_name']);
  sessionStorage.setItem("admin_key",res['data']['admin_key']);
  sessionStorage.setItem("mypl",res['data']['mypl']);
  sessionStorage.setItem("pb_client_id",res['data']['pb_client_id']); 
  sessionStorage.setItem("epic_link", res['data']['epic_link']);
  sessionStorage.setItem("mypl_id", res['data']['mypl_id']);
  sessionStorage.setItem("property_id", res['data']['ga4_property_id']);
  sessionStorage.setItem("targeting_access_key", res['data']['client_gt']);
  
  //sessionStorage.setItem("seo_tab", res['data']['seo_tab']);
  // sessionStorage.setItem("imageProfile", res['data']['imageProfile']);
 this.dataService.client_name=sessionStorage.getItem("firstName")+" "+sessionStorage.getItem("lastName");
 this.dataService.client_img=sessionStorage.getItem("client_profile_image");
 this.dataService.adminurl=sessionStorage.getItem("website")+"/pbvault_signin/verify.php/?key="+sessionStorage.getItem('admin_key')+"&path="+sessionStorage.getItem("web_admin_name")+"&tk="+(Math.floor(Math.random()*90000) + 10000);
 this.dataService.rmurl="https://expertpracticemarketing.com/myprac1/public/api/pb-integration/get/param/safari-auth/access_key/"+sessionStorage.getItem("mypr_access_key");
 if(sessionStorage.getItem('admin_key')=='')
    {
      this.dataService.admin_visit=1;
    }
  else
  {
    this.dataService.admin_visit=0;
  }  
 if(sessionStorage.getItem('is_rm')=='0')
    {
      this.dataService.rm_visit=1;
    }
  else
  {
    this.dataService.rm_visit=0;
  }      
  this.router.navigate(['/dashboard']);

}
else
{
  this.dataService.isload=false;
  this.toastr.showError("Invalid Username Or Password !!");
  //console.log("Invalid Credential");
  // this.login_msg="Invalid Username Or Password !!";
}
}
)  
//let message:boolean=this.dataService.getuser(param.user,param.pass);


}

set_userdata(res)
{
  
  //console.log(res);
  

}
  ngOnInit() {
    console.log(sessionStorage.getItem("isLogedin"));
    //alert(sessionStorage.getItem("isLogedin"));
   if(sessionStorage.getItem("isLogedin")=='true' && sessionStorage.getItem("actdashboard")=='true')
    {
       this.router.navigate(['/dashboard']);
      
    }
    if(sessionStorage.getItem("isLogedin")=='true' && sessionStorage.getItem("actseo")=='true')
    {
       this.router.navigate(['/seo']);
      
    }

    if(sessionStorage.getItem("isLogedin")=='true' && sessionStorage.getItem("actsm")=='true')
    {
       this.router.navigate(['/sm']);
      
    }

    if(sessionStorage.getItem("isLogedin")=='true' && sessionStorage.getItem("actrm")=='true')
    {
       this.router.navigate(['/rm']);
      
    }

    if(sessionStorage.getItem("isLogedin")=='true' && sessionStorage.getItem("actmypl")=='true')
    {
       this.router.navigate(['/mypl']);
      
    }

    if(sessionStorage.getItem("isLogedin")=='true' && sessionStorage.getItem("actwebadmin")=='true')
    {
       this.router.navigate(['/webadmin']);
      
    }

    if(sessionStorage.getItem("isLogedin")=='true' && sessionStorage.getItem("actpbform")=='true')
    {
       this.router.navigate(['/pbform']);
      
    }

    if(sessionStorage.getItem("isLogedin")=='true' && sessionStorage.getItem("actticketlist")=='true')
    {
       this.router.navigate(['/ticket-list']);
      
    }

    if(sessionStorage.getItem("isLogedin")=='true' && sessionStorage.getItem("actcreateissue")=='true')
    {
       this.router.navigate(['/create-issue']);
      
    }
    if(sessionStorage.getItem("isLogedin")=='true' && sessionStorage.getItem("actam")=='true')
    {
       this.router.navigate(['/am']);
      
    }
    else
    {
      
    }
  }

  


}
